import React, { useState } from "react";
import Layout from "../../../components/layout/Layout";
import { MdFileDownload } from "react-icons/md";
import Competitions from "../../Competitions/Competitions";
import { CloseSquare, Edit, Edit2, Eye, Category } from "iconsax-react";
import { Field, FieldArray, Form, Formik } from "formik";
import { Dialog } from "@mui/material";
import useRolesLogic from "./useRolesLogic";
import usePermissionsLogic from "../Permissions/usePermissionsLogic";
import { useFetchPermissions } from "../../../hooks/api";

function Roles() {
  const { rolesList, handleSearchTerm } = useRolesLogic();
  const { fetchAllPermissions } = usePermissionsLogic();
  const [showAddRolesCard, setShowAddRolesCard] = useState(false);

  function toggleRolesCardModal() {
    setShowAddRolesCard((prev) => !prev);
  }
  return (
    <Layout pageName="Users">
      <section className="mt-3">
        <AddRoles
          open={showAddRolesCard}
          handleClose={toggleRolesCardModal}
          permissionList={fetchAllPermissions.data}
        />
        <div className="flex items-center justify-between">
          <h2 className="text-[#4E5566] text-lg font-semibold">Roles</h2>
          <button
            className="btn bg-[#4E5566] px-10 text-white"
            onClick={toggleRolesCardModal}
          >
            Create Role
          </button>
        </div>
        <div className="bg-white rounded-md p-3 mt-5">
          <div className="card  bg-white  rounded ">
            <div className="flex items-center justify-between">
              <h4 className="text-sm">View Roles</h4>
              <div className="flex items-center">
                <label className="input input-sm input-bordered flex items-center gap-2 mr-3">
                  <input
                    type="text"
                    className="grow "
                    placeholder="Search role"
                    onChange={handleSearchTerm}
                  />
                  <kbd className="kbd kbd-sm">⌘</kbd>
                  {/* <kbd className="kbd kbd-sm">K</kbd> */}
                </label>

                <button className="btn btn-sm btn-outline">
                  <MdFileDownload />{" "}
                </button>
              </div>
            </div>
          </div>

          <div className=" mt-4 bg-white rounded-lg">
            <table className="table">
              <thead className="bg-[#F5F5F5]">
                <tr>
                  <th>No</th>
                  <th>Role</th>
                  {fetchAllPermissions.data?.map((item) => (
                    <th key={item.id}>{item.name}</th>
                  ))}
                  {/* <th>Users</th>
                  <th>Plan</th>
                  <th>Revenue</th>
                  <th>Subscription</th>
                  <th>Subscribers</th>
                  <th>Source</th>
                  <th>Competition</th>
                  <th>Analytics</th> */}
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody className="font-xs font-normal">
                {rolesList.data?.data?.map((role, index) => (
                  <tr
                    className="font-xs font-normal items-center"
                    key={role.id}
                  >
                    <th>{index + 1} </th>

                    <th className="font-xs font-normal">{role.name}</th>
                    {fetchAllPermissions.data?.map((permission) => (
                      <th className="font-xs font-normal ">
                        <div className="flex gap-1 items-center ">
                          {role.permissions
                            ?.find(
                              (rp) =>
                                rp.permission_details?.id === permission?.id
                            )
                            ?.privileges?.includes("Read") && (
                            <Eye size="16" color="#828A9B" />
                          )}
                          {role.permissions
                            ?.find(
                              (rp) =>
                                rp.permission_details?.id === permission?.id
                            )
                            ?.privileges?.includes("Update") && (
                            <Edit size="16" color="#828A9B" />
                          )}
                          {role.permissions
                            ?.find(
                              (rp) =>
                                rp?.permission_details?.id === permission?.id
                            )
                            ?.privileges?.includes("Create") && (
                            <Edit2 size="16" color="#828A9B" />
                          )}
                          {JSON.parse(
                            role.permissions?.find(
                              (rp) =>
                                rp.permission_details?.id === permission?.id
                            )?.privileges || "[]"
                          )?.length > 1 ? (
                            ""
                          ) : (
                            <p className="text-center px-4">-</p>
                          )}
                          {/* {JSON.stringify(
                            role.permissions?.find(
                              (rp) => rp.permission_details.id === permission.id
                            )?.privileges
                          )} */}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}

                {rolesList.isLoading && (
                  <div className="  loading loading-spinner"></div>
                )}
              </tbody>
            </table>

            <div className=" flex items-center gap-2 mt-5">
              <div className=" flex items-center gap-1">
                <p className="text-xs font-semibold">Create =</p>{" "}
                <Edit2 size="16" color="#828A9B" />
              </div>
              <div className=" flex items-center gap-1">
                <p className="text-xs font-semibold">Edit =</p>{" "}
                <Edit size="16" color="#828A9B" />
              </div>
              <div className=" flex items-center gap-1">
                <p className="text-xs font-semibold">View =</p>{" "}
                <Eye size="16" color="#828A9B" />
              </div>
            </div>

            <p className="mt-3 text-xs">Only Super admin can create roles</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Roles;

type AddCardUser = {
  open: boolean;
  handleClose: () => any;
  permissionList?: Permission[];
};
function AddRoles(props: AddCardUser) {
  const { createRole, rolesList, setFilters } = useRolesLogic();
  // You can now use setFilters to set the filters anywhere

  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <div className="p-6 w-[500px]">
        <div className=" w-full mb-4 flex items-center justify-between">
          <p className="font-bold text-sm">Add New Users</p>
          <button onClick={props.handleClose}>
            <CloseSquare size="22" color="#071839" />
          </button>
        </div>

        <Formik
          initialValues={{
            rolename: "",
            category: [
              {
                type: {
                  edit: false,
                  view: false,
                  create: false,
                },
                name: "",
              },
            ],
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            let payload: CreateRolePayload = {
              name: values.rolename,
              permissions: values.category.map((item) => {
                let priviledges: ("Create" | "Read" | "Update" | "Delete")[] =
                  [];
                if (item.type.create) {
                  priviledges.push("Create");
                }
                if (item.type.edit) {
                  priviledges.push("Update");
                }
                if (item.type.view) {
                  priviledges.push("Read");
                }

                return { permission_id: item.name, privileges: priviledges };
              }),
            };

            createRole.mutate(payload, {
              onSuccess: (roleResponse) => {},
              onSettled: () => {
                rolesList.refetch();
                props.handleClose();
                setSubmitting(false);
              },
            });
          }}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <div className="">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Role Name:
                  </p>
                  <Field
                    name="rolename"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              <FieldArray name="category">
                {({ insert, push, remove }) => (
                  <div className="">
                    {values.category?.map((item, index) => (
                      <div className=" my-2 flex justify-between">
                        <div className=" ">
                          <div className=" mb-3">
                            <label className="form-control w-full max-w-xs">
                              <p className="label text-xs text-[#4E5566] font-semibold">
                                Category:
                              </p>
                              <Field
                                as="select"
                                name={`category.[${index}].name`}
                                className="input input-bordered outline-none w-full max-w-xs"
                              >
                                <option value="" disabled>
                                  Select Permission
                                </option>
                                {props.permissionList?.map((permission) => (
                                  <option
                                    value={permission?.id}
                                    key={permission?.id}
                                  >
                                    {" "}
                                    {permission.name}
                                  </option>
                                ))}
                              </Field>
                            </label>
                          </div>
                          <div className=" flex items-center gap-1">
                            <div className="form-control">
                              <label className="label cursor-pointer gap-2">
                                <span className="label-text flex items-center gap-0.5">
                                  <Edit size={12} /> Create
                                </span>
                                <Field
                                  type="checkbox"
                                  name={`category.[${index}].type.create`}
                                  className="toggle toggle-xs"
                                />
                              </label>
                            </div>
                            <div className="form-control">
                              <label className="label cursor-pointer gap-2">
                                <span className="label-text flex items-center gap-0.5">
                                  <Edit2 size={12} /> Edit
                                </span>
                                <Field
                                  type="checkbox"
                                  name={`category.[${index}].type.edit`}
                                  className="toggle toggle-xs"
                                />
                              </label>
                            </div>
                            <div className="form-control">
                              <label className="label cursor-pointer gap-2">
                                <span className="label-text flex items-center gap-0.5">
                                  <Eye size={12} /> View
                                </span>
                                <Field
                                  type="checkbox"
                                  name={`category.[${index}].type.view`}
                                  className="toggle toggle-xs"
                                />
                              </label>
                            </div>
                          </div>
                        </div>

                        <button type="button" onClick={() => remove(index)}>
                          <CloseSquare color="red" />
                        </button>
                      </div>
                    ))}
                    <div className="flex justify-end my-2">
                      <button
                        onClick={() =>
                          push({
                            name: "",
                            type: { edit: false, view: false, create: false },
                          })
                        }
                        type="button"
                        className="font-bold text-sm"
                      >
                        {" "}
                        + Add More
                      </button>
                    </div>
                  </div>
                )}
              </FieldArray>
              <div className=" mt-4">
                <button
                  className="btn btn-outlined w-full bg-[#071839ea] text-white hover:bg-[#071839] "
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving" : "  Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
}
